import { createFileRoute } from "@tanstack/react-router";
import SitePage from "@/components/SitePage";
import { buildHead, breadcrumbLD, touristTripLD, faqLD, SITE_URL } from "@/content/seo";

const TITLE = "Alvor Lagoon Cruise from Vilamoura · Morningstar Yacht";
const DESC = "Private day cruise from Vilamoura to the Alvor lagoon and western Algarve — Benagil, Marinha, Carvoeiro and the protected Alvor estuary. Onboard catering, swim stops.";
const PATH = "/alvor-lagoon-cruise";
const URL = `${SITE_URL}${PATH}`;

export const Route = createFileRoute("/alvor-lagoon-cruise")({
  component: () => (
    <SitePage
      lang="en"
      heroOverride={{
        eyebrow: "Alvor Lagoon · From Vilamoura · Algarve",
        title: "Alvor lagoon cruise from Vilamoura on ",
        titleAccent: "Morningstar.",
        sub: "A long private day west — past Benagil and Marinha to the calm Alvor estuary. Long swim stop, lunch on board and the prettiest cliffs of the Algarve.",
        ctaPrimary: "View itinerary",
        ctaSecondary: "Ask about Alvor",
      }}
    />
  ),
  head: () =>
    buildHead({
      lang: "en",
      path: PATH,
      title: TITLE,
      description: DESC,
      keywords: "Alvor boat trip, Alvor lagoon cruise, Vilamoura to Alvor boat, western Algarve cruise, Carvoeiro boat tour",
      altPath: { en: PATH, pt: "/pt/cruzeiro-laguna-alvor" },
      extraScripts: [
        {
          type: "application/ld+json",
          children: JSON.stringify(
            touristTripLD({
              name: "Alvor Lagoon Cruise from Vilamoura",
              description: DESC,
              url: URL,
            }),
          ),
        },
        {
          type: "application/ld+json",
          children: JSON.stringify(
            breadcrumbLD([
              { name: "Home", path: "/" },
              { name: "Alvor Lagoon Cruise", path: PATH },
            ]),
          ),
        },
        { type: "application/ld+json", children: JSON.stringify(faqLD("en")) },
      ],
    }),
});
